<h3 mat-dialog-title>Visualizar Carteira Crédito/Câmbio/Consórcio</h3>
<div mat-dialog-content>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        
        <strong>Cliente: </strong>{{model.cliente.nome}} <br>
            
    </div>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <strong>Empresa: </strong>{{model.empresa_consorcio.nome}}
    </div>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <strong>Tipo Operação: </strong>{{model.tipo_consorcio.nome}}
    </div>

    
    <div fxLayout="row wrap" fxLayoutAlign="space-between" >
        <div floatLabel="always" fxFlex="45">
            <strong>GRUPO: </strong> {{model.grupo}}
        </div>

        <div floatLabel="always" fxFlex="45">
            <strong>COTA: </strong> {{model.cota}}
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between" >
        <div floatLabel="always" fxFlex="45">
            <strong>Prazo Grupo</strong> {{model.prazo_grupo}}
        </div>

        <div floatLabel="always" fxFlex="45">
            <strong>Prazo Cliente</strong> {{model.prazo_cliente}}
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between" >
        <div fxFlex="45">
            <strong>Taxa de Adminstração: </strong> R$ {{model.taxa_administracao | number : '1.2-2'}}
        </div>

        <div fxFlex="45">
            <strong>Data de Autorização: </strong> {{model.data_atualizacao}}
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between" >
        <div fxFlex="45">
            <strong>Valor Contratado: </strong> R$ {{model.taxa_administracao | number : '1.2-2'}}
        </div>

        <div fxFlex="45">
            <strong>Valor Lance em Potencial: </strong> R$ {{model.valor_lance_potencial | number : '1.2-2'}}
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between" >
        <div fxFlex="45">
            <strong>Valor Lance Efetivado: </strong> R$ {{model.valor_lance_efetivado_contemplacao | number : '1.2-2'}}
        </div>

        <div fxFlex="45">
            <strong>Valor Reembolso: </strong> R$ {{model.valor_reembolso | number : '1.2-2'}}
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between" >
        <div fxFlex="45">
            <strong>Valor Pago: </strong> R$ {{model.valor_pago | number : '1.2-2'}}
        </div>
        <div fxFlex="45">
            <strong>Saldo devedor: </strong> R$ {{model.saldo_devedor | number : '1.2-2'}}
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between" >
        <div fxFlex="45">
            <strong>Data da Liberação do Crédito: </strong> {{model.liberacao_credito}}
        </div>
        <div fxFlex="45">
            <strong>Valor Crédito Liberado: </strong> R$ {{model.valor_credito_liberado | number : '1.2-2'}}
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between" >
        <div fxFlex="45">
            <strong>Valor Crédito Autorizado: </strong> R$ {{model.credito_autorizado | number : '1.2-2'}}
        </div>
    </div>

</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Fechar</button>
</div>